import { NumberKMPipe } from './../../../../../pipes/numberKMPipe';
import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../../models/search-toolbar-factory-parameters.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-promo-overview-loyalty-1-1',
  templateUrl: './overview-loyalty-1-1.component.html',
  styleUrls: ['./overview-loyalty-1-1.component.css']
})
// Pagina 50
export class PromoOverviewLoyalty11Component implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public storeError = false;
  public selectOneError: string;
  public data: QFilterModel;
  public revenueInvestmentColumn: LoyaltyChart;
  public revenueTargetLine: LoyaltyChart;
  public datatablePromo: Array<any>;


  constructor (
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {

    this.translate.get([
      'promo.categoryInvestmentTypePromo',
      'promo.averageDiscountPerStoreChannel',
      'promo.investmentContactChannel',
      'promo.obiettivo_iniziativa',
      'promo.numero_campagne_totali',
      'promo.investimento_totale',
      'promo.sconto_medio',
      'promo.redemption',
      'promo.spesa_incrementale',
      'promo.spesa_incrementale_baseline',
      'promo.spesa_associata',
      'promo.roi',
      'promo.fatturato_promo',
      'promo.investimento_totale',
      'promo.investimento_fatturato_promo',
      'promo.fatturato_target_group_control_group'
    ]).subscribe((t) => {
      this.translations = {
        categoryInvestmentTypePromo: t['promo.categoryInvestmentTypePromo'],
        averageDiscountPerStoreChannel: t['promo.averageDiscountPerStoreChannel'],
        investmentContactChannel: t['promo.investmentContactChannel'],
        obiettivo_iniziativa: t['promo.obiettivo_iniziativa'],
        numero_campagne_totali: t['promo.numero_campagne_totali'],
        sconto_medio: t['promo.sconto_medio'],
        redemption: t['promo.redemption'],
        spesa_incrementale: t['promo.spesa_incrementale'],
        spesa_incrementale_baseline: t['promo.spesa_incrementale_baseline'],
        spesa_associata: t['promo.spesa_associata'],
        roi: t['promo.roi'],
        fatturato_promo: t['promo.fatturato_promo'],
        investimento_totale: t['promo.investimento_totale'],
        investimento_fatturato_promo: t['promo.investimento_fatturato_promo'],
        fatturato_target_group_control_group: t['promo.fatturato_target_group_control_group']
      };
    });

    this.translate.get('store.selectOneErrorMsg').subscribe(msg => {
      this.selectOneError = msg;
    });

    this.initCharts();
  }

  initCharts() {

    this.revenueInvestmentColumn = new LoyaltyChart('column');
    this.revenueInvestmentColumn.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom'};  /*Q206*/
    this.revenueInvestmentColumn.options.plotOptions = {area: {stacking: 'normal'}};
    this.revenueInvestmentColumn.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.revenueInvestmentColumn.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };

    this.revenueTargetLine = new LoyaltyChart('line');
    this.revenueTargetLine.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom'};
    this.revenueTargetLine.options.chart.zoomType = 'xy';
    this.revenueTargetLine.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.revenueTargetLine.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    Observable.zip(
      this.indicatorService.indicatorCalculation('promos.Q211', this.data),
      this.indicatorService.indicatorCalculation('promos.Q214', this.data)
    ).subscribe(([q211, q214]) => {

      /*211*/
      this.indicators.push(new IndicatorBoxModel([q211.find(r => r.name === 'numero_campagne_totali')], {dynamic: true, decimal_value: 0, decimal_prec_value: 0}));
      /*212*/
      this.indicators.push(new IndicatorBoxModel([q211.find(r => r.name === 'investimento_totale')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      /*213*/
      this.indicators.push(new IndicatorBoxModel([q211.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*215*/
      this.indicators.push(new IndicatorBoxModel([q214.find(r => r.name === 'spesa_incrementale')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      /*214*/
      this.indicators.push(new IndicatorBoxModel([q211.find(r => r.name === 'fatturato_promo')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}));
      /*216*/
      this.indicators.push(new IndicatorBoxModel([q214.find(r => r.name === 'roi')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}));
      /*217*/
      this.indicators.push(new IndicatorBoxModel([q214.find(r => r.name === 'redemption')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*218*/
      this.indicators.push(new IndicatorBoxModel([q214.find(r => r.name === 'spesa_incrementale_baseline')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));

    });

    this.revenueInvestmentColumnInit (data);
    this.revenueTargetLineInit (data);
    this.tableInit(data);
    this.show_results = true;
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  revenueInvestmentColumnInit(data) {

    this.indicatorService.getChart('promos.Q219', data, false).subscribe(res => {

      let series = [
        {name: this.translations.fatturato_promo, data: res.series[3].serie},
        {name: this.translations.investimento_totale, data: res.series[1].serie}
      ];
      let cat = res.series[0].serie;
      for (let i = 0; i < cat.length; i++) {
        cat[i] = cat[i].split('-').reverse().join('/');
      }

      if (this.revenueInvestmentColumn.instance) {
        while (this.revenueInvestmentColumn.instance.series.length > 0) {
          this.revenueInvestmentColumn.instance.series[0].remove(true);
        }
      }

      this.revenueInvestmentColumn.options.xAxis.categories = cat;

      for (let i = 0; i < series.length; i++) {

        this.revenueInvestmentColumn.instance.addSeries(series[i]);
      }
      this.revenueInvestmentColumn.instance.update(this.revenueInvestmentColumn.options);
      this.revenueInvestmentColumn.instance.redraw();
    });
  }

  revenueTargetLineInit(data) {
    this.chartsService.loadChart(this.revenueTargetLine, 'promos.Q220', data, this.indicatorService, this.translate, false, LoyaltyChart.colors, 'promo');
  }

  public tableInit(data: QFilterModel) {
    this.indicatorService.getChart('promos.Q221', data).subscribe((resp) => {

      this.datatablePromo = [];
      if (resp.series.length > 0) {
        let serie0 = resp.series[0].serie;
        let serie1 = resp.series[1].serie;
        let serie2 = resp.series[2].serie;
        let serie4 = resp.series[4].serie;
        let serie6 = resp.series[6].serie;
        let serie8 = resp.series[8].serie;
        let serie10 = resp.series[10].serie;
        let serie12 = resp.series[12].serie;
        let serie14 = resp.series[14].serie;

        for (let i = 0; i < serie0.length; i++) {

          this.datatablePromo.push({
            obiettivo_iniziativa: serie0[i],
            numero_campagne_totali: serie1[i],
            investimento_totale: this.formatDynamic (serie2[i]),
            sconto_medio: serie4[i],
            redemption: serie6[i],
            spesa_incrementale: this.formatDynamic (serie8[i]),
            spesa_incrementale_baseline: serie10[i],
            spesa_associata: this.formatDynamic (serie12[i]),
            roi: serie14[i]

          });
        }
      }
    });

  }

  formatDynamic(x: number): number {
    switch (true) {
      case +x >= 1000000:
        return (x / 1000000);
      case +x >= 1000:
        return x / 1000;
      default:
        return x;
    }
  }

  resetData() {
    this.show_results = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/overview-loyalty-1-1/overview-loyalty-1-1.component.ts